export const CLICKED_CONTINUE_BUTTON = 'Clicked Contest Launch Continue Button';
export const STARTED_LAUNCH = 'Started Contest Launch';
export const VIEWED_LAUNCH_STEP = 'Viewed Contest Launch Step';
export const SHORTLISTED_DESIGNS = 'Shortlisted Designs';
